<div
  class="d-flex flex-wrap align-items-center date-range"
  [class.gray-view]="isGrayView"
  [class.no-field-underline]="isGrayView"
  [formGroup]="dateForm"
>
  <mat-form-field
    class="date-field custom-datepicker"
    appearance="fill"
    [style.width.%]="isEventColumn ? 45 : 'unset'"
  >
    <input
      class="mat-datepicker-input"
      formControlName="start"
      matInput
      [matDatepicker]="picker1"
      [max]="endMaxDate"
    />
    <mat-datepicker-toggle matSuffix [for]="picker1">
      @if (isGrayView) {
        <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
      } @else {}
    </mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
  </mat-form-field>
  <span class="mat-datepicker-input range">to</span>
  <mat-form-field
    class="date-field custom-datepicker"
    appearance="fill"
    [style.width.%]="isEventColumn ? 45 : 'unset'"
  >
    <input
      class="mat-datepicker-input"
      formControlName="end"
      [matDatepickerFilter]="minFilter"
      matInput
      [matDatepicker]="picker2"
      [max]="endMaxDate"
    />
    <mat-datepicker-toggle matSuffix [for]="picker2">
      @if (isGrayView) {
        <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
      } @else {
        <!--  <img src="assets/svg/datepicker.svg" alt="calendar" matDatepickerToggleIcon />-->
      }
    </mat-datepicker-toggle>
    <mat-datepicker #picker2></mat-datepicker>
  </mat-form-field>
</div>
